import { _ as _define_property } from "@swc/helpers/_/_define_property";
import * as relationshipModel from './relationship';
import { RelationshipStatus } from './relationship';
import { ServiceSource } from './service/model';
export class AgreementDataModel {
    static make(data) {
        return new AgreementDataModel(data.netTerms, data.autoPayment, data.status, data.effectiveDate, data.daysToEffectiveDate);
    }
    static fromRelationship(relationship) {
        return new AgreementDataModel(relationshipModel.actualNetTerms(relationship), !relationship.allowManualPayments, relationship.status, relationship.effectiveDate, relationship.daysToEffectiveDate);
    }
    static fromDraft(draft) {
        return new AgreementDataModel(draft.netTerms(), !draft.allowManualPayments(), RelationshipStatus.Pending, draft.effectiveDate(), 0);
    }
    setNetTerms(netTerms) {
        return new AgreementDataModel(netTerms, this.autoPayment, this.status, this.effectiveDate, this.daysToEffectiveDate);
    }
    isActiveAgreement() {
        return this.status !== RelationshipStatus.Pending;
    }
    isPending() {
        return this.status === RelationshipStatus.Pending;
    }
    serviceSource() {
        return this.isActiveAgreement() ? ServiceSource.Amendment : ServiceSource.Draft;
    }
    constructor(netTerms, autoPayment, status, effectiveDate, daysToEffectiveDate){
        _define_property(this, "netTerms", void 0);
        _define_property(this, "autoPayment", void 0);
        _define_property(this, "status", void 0);
        _define_property(this, "effectiveDate", void 0);
        _define_property(this, "daysToEffectiveDate", void 0);
        this.netTerms = netTerms;
        this.autoPayment = autoPayment;
        this.status = status;
        this.effectiveDate = effectiveDate;
        this.daysToEffectiveDate = daysToEffectiveDate;
    }
}
